<div class="input-container">
    <label
        [ngClass]="{
            'label': true,
            'label-animation': control.value,
            'has-icon': iconName,
            'kk-visuallyhidden': !control.value
        }"
        [for]="control | controlToKeyName"
        >{{ label }}</label
    >
    <div class="icon" *ngIf="iconName">
        <app-svg-icon [iconName]="iconName"></app-svg-icon>
    </div>
    <input
        class="input"
        [ngClass]="{
            'has-icon': iconName,
            'input-label-padding': control.value
        }"
        [formControl]="formControl"
        [name]="control | controlToKeyName"
        [placeholder]="placeholder"
        [attr.maxlength]="maxlength"
        [type]="type"
        [autocomplete]="autocomplete"
        [attr.aria-label]="label"
        (focus)="onFocus()"
        (blur)="onBlur()"
        [appAutoFocus]="autoFocus"
    />
</div>
